// getShortLinkData.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

/**
 * Select shortended link by full href
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} key - select key.
 * @return {string} The selected short link.
 */
const getShortLinkData = createCachedSelector(
  state => state,
  (state, key) => key,
  (state, key) => {
    const result = state.getIn(['shortLink', key]);
    return result instanceof Collection ? result.toJS() : result;
  }
)((state, link) => `shortLink:${link}`);

export default getShortLinkData;
